import { requestApi } from '@app/api';
import { withBulkRequest } from '@app/api/paths';
import { MutateBulkRequestResponse } from '@app/store/transport-layer/bulk-request/bulk-requests';

export interface PostBulkRequestsCancelParams {
  message: string;
  blockSignerAccess: boolean;
}

export function postBulkRequestsCancel(
  workspaceId: string,
  bulkRequestId: string,
  data: PostBulkRequestsCancelParams
): Promise<MutateBulkRequestResponse> {
  return requestApi<MutateBulkRequestResponse>({
    url: withBulkRequest(`/workspaces/${workspaceId}/bulk-requests/${bulkRequestId}/cancel`),
    method: 'POST',
    credentials: true,
    data,
  }).then((response) => response.data);
}
